export default __webpack_public_path__ + "static/chip_art-03@2x_1-417c471ac5e99ebafe5e5dfa6552803c.jpeg";